module.exports = __webpack_public_path__ + "img/silver3.f2167cb9.png";